import { SET_SEARCH_DATA_LOADING } from "../actions";

export const searchDataLoading = (state = true, action) => {
  if (action.type === SET_SEARCH_DATA_LOADING) {
    return action.payload;
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/store/reducers/searchDataLoading.js